import { render, staticRenderFns } from "./CredentialProcessTypeSave.vue?vue&type=template&id=4e6dd6b5&"
import script from "./CredentialProcessTypeSave.vue?vue&type=script&lang=js&"
export * from "./CredentialProcessTypeSave.vue?vue&type=script&lang=js&"
import style0 from "./CredentialProcessTypeSave.vue?vue&type=style&index=0&id=4e6dd6b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports